import { Analytics } from '@analytics';
import ShareInviteIcon from '@assets/images/Share_Invite.png';
import { Button } from '@material-ui/core';
import { formatRegionalLinks } from '@utils/helpers';
import { default as React } from 'react';
import { useIntl } from 'react-intl';
import messages from './messages';

// `compact` is the desktop rail's tighter spacing (card 383); the mobile menu
// keeps the original.
const ShareCompanyInviteButton = ({ companyName, inviteCode, compact = false }) => {
  const intl = useIntl();

  return (
    <Button
      className={`!mx-3 ${compact ? '!my-1.5 !text-[13px]' : '!my-[11px]'} w-[calc(100%-24px)] !rounded-xl !bg-white hover:!bg-slate-50 !text-slate-700 !font-semibold !normal-case !border !border-solid !border-slate-300 !shadow-sm transition-colors flex flex-row justify-center`}
      variant="contained"
      color="primary"
      onClick={() => {
        Analytics.track('share company invite link clicked');

        navigator.share({
          title: `Join ${companyName} on TipDirect`,
          url: formatRegionalLinks(`signupfrominvite/${inviteCode}`)
        });
      }}>
      <img className="h-5 mr-2.5" src={ShareInviteIcon} alt={'Share Invite'} />
      {intl.formatMessage(messages.companyInvite)}
    </Button>
  );
};

export default ShareCompanyInviteButton;
